import { Link, useLocation, type LinkProps } from '@remix-run/react'
import { type ReactNode } from 'react'

const InternalLink = ({
	to,
	target = '_self',
	children,
	prefetch = 'none',
	additionalClasses = '',
	key = '',
}: {
	to: string
	target?: string
	children: ReactNode
	prefetch?: LinkProps['prefetch']
	additionalClasses?: string
	key?: string
}) => {
	const location = useLocation()

	return (
		<Link
			to={to}
			target={target}
			state={{ from: location.pathname }}
			prefetch={prefetch}
			className={additionalClasses}
		>
			{children}
		</Link>
	)
}

export default InternalLink
